// removed by extract-text-webpack-plugin
module.exports = {"modalWrapper":"DOpkOrOlt-hvurWbET7CR","modal":"_3PquGSzgY2MQnNYRn02xXY","shrink-bounce":"gYvJDZTKuwlctl8vkNMi7","topBar":"_3_aZc2m9b4hz5gT-omxsC9","alert":"_1HsiQuJ327uidM2VTGmSnO","warning":"usvbf53EjBoZ-HQBZNGG2","info":"_1EWnSIsm3u6HgFXx0pqvZS","success":"ms3GT1X__sqRKROpmzeaA","title":"_2Dpw3PKG9qFay2OYLrwKfy","closeButton":"_1SwKqczGuDPQBOiTHWYoVI","content":"_32e1wxqeDWDcTywg0erGK","contentText":"_2tdx-Siqcb1KIkvTuAy2E1"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/sharedComponents/css/modalPopup.css
// module id = 1033
// module chunks = 0